<template>
	<div class="flex gap-8">
		<input
			:id="id ?? name"
			v-model="model"
			:class="[
				'size-7 col-start-1 row-start-1 appearance-none rounded-full border border-gray-300 bg-white',
				'checked:border-brand-600 checked:bg-brand-600 indeterminate:border-gray-300',
				'checked:focus:bg-brand-600 checked:focus:ring-brand-600 focus:ring-brand-600',
				'indeterminate:bg-white focus-visible:outline focus-visible:outline-2',
				'focus-visible:outline-offset-2 focus-visible:outline-brand-600 disabled:border-gray-300',
				'disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto',
			]"
			type="radio"
			:title="title"
			:name="name"
			:disabled="isDisabled"
			:readonly="isReadonly"
			:required="isRequired"
			:value="value"
		>
		<label
			:for="id ?? name"
			class="font-medium text-gray-900 text-functional-size-md flex flex-col gap-2"
		>
			<span>
				<slot>{{ title }}</slot>
			</span>

			<span
				v-if="description"
				data-testid="atom-input-radio-description"
				class="block text-gray-500 text-functional-size-sm"
			>
				{{ description }}
			</span>
		</label>
	</div>
</template>

<script setup lang="ts">
const {
	isRequired,
	isDisabled,
} = defineProps<{
	id?: string;
	name: string;
	isDisabled?: boolean;
	isReadonly?: boolean;
	isRequired?: boolean;
	title?: string;
	description?: string;
	value?: string;
}>();

const model = defineModel<boolean | string>();
</script>
